var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1234.25 434.03",
    style: {
      enableBackground: "new 0 0 1234.25 434.03"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000053509576774520073700000006627230707948980665_);fill:#E6007E;}\n\t.st1{clip-path:url(#SVGID_00000053509576774520073700000006627230707948980665_);fill:#F28C00;}\n\t.st2{clip-path:url(#SVGID_00000053509576774520073700000006627230707948980665_);fill:#00B1EB;}\n\t.st3{clip-path:url(#SVGID_00000053509576774520073700000006627230707948980665_);fill:#536AB1;}\n\t.st4{clip-path:url(#SVGID_00000053509576774520073700000006627230707948980665_);fill:#6C6B6A;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.02,
    width: 1234.22,
    height: 434
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120531156852957785440000000305437222228899458_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120531156852957785440000000305437222228899458_)",
      fill: "#E6007E"
    },
    d: "M0,217.01 C0,97.18,97.15,0,217.01,0v217.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120531156852957785440000000305437222228899458_)",
      fill: "#F28C00"
    },
    d: "M217,217.01 c119.84,0,217.01-97.15,217.01-217.01H217V217.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120531156852957785440000000305437222228899458_)",
      fill: "#00B1EB"
    },
    d: "M434,217.01 c0,119.84-97.15,217.01-217.01,217.01V217.01H434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120531156852957785440000000305437222228899458_)",
      fill: "#536AB1"
    },
    d: "M0,434.01 C0,314.18,97.15,217,217.01,217v217.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120531156852957785440000000305437222228899458_)",
      fill: "#6C6B6A"
    },
    d: "M470.64,242v-53.09 c0-72.91,42.91-117.43,113.14-117.43c27.35,0,49.88,7.52,67.02,20.93V76.32h56.3v278.3h-56.3v-16.09 c-17.14,13.41-39.68,20.9-67.02,20.9C513.55,359.43,470.64,314.94,470.64,242 M589.15,305.82c37,0,61.66-16.09,61.66-63.82v-53.09 c0-42.36-24.66-63.79-61.66-63.79c-38.6,0-62.21,21.43-62.21,63.79V242C526.94,289.72,550.55,305.82,589.15,305.82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120531156852957785440000000305437222228899458_)",
      fill: "#6C6B6A"
    },
    d: "M740.92,261.31h56.3 c0,27.35,20.93,45.04,59.53,45.04c38.07,0,56.85-15.01,56.85-32.71c0-13.94-8.6-24.66-31.66-29.5l-60.06-11.78 c-40.76-7.52-69.71-33.26-69.71-77.75c0-45.59,39.68-83.12,105.1-83.12s108.33,39.15,108.33,91.16h-55.24 c-1.08-25.21-23.06-39.68-53.09-39.68c-30.55,0-48.25,13.94-48.25,30.55c0,15.54,11.81,23.59,29.5,27.35l58.98,11.25 c52.54,9.65,74.52,41.31,74.52,79.91c0,47.17-41.81,87.4-115.27,87.4C791.33,359.44,742.52,326.2,740.92,261.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120531156852957785440000000305437222228899458_)",
      fill: "#6C6B6A"
    },
    d: "M997.79,243.61v-56.3 c0-72.94,48.25-115.82,118.51-115.82c69.18,0,115.27,38.07,117.43,103.49h-56.3c-1.63-33.26-25.22-49.88-61.13-49.88 c-37,0-62.21,20.9-62.21,62.21v56.3c0,46.65,25.22,62.21,62.21,62.21c36.47,0,60.06-12.88,61.13-49.88h56.3 c-2.16,65.42-48.8,103.49-117.43,103.49C1046.04,359.44,997.79,316.53,997.79,243.61"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000120531156852957785440000000305437222228899458_)",
      fill: "#6C6B6A"
    },
    d: "M1216.05,0.63 c10.13,0,18.2,5.56,18.2,16.64v6.17c0,11.08-8.07,16.64-18.2,16.64c-10.13,0-18.17-5.56-18.17-16.64v-6.17 C1197.88,6.2,1205.93,0.63,1216.05,0.63 M1216.05,36.7c8.35,0,14.49-3.71,14.49-13.26v-6.17c0-9.55-6.14-13.23-14.49-13.23 c-8.32,0-14.49,3.68-14.49,13.23v6.17C1201.57,32.99,1207.73,36.7,1216.05,36.7 M1209.44,10.56h8.05c4.06,0,6.62,1.91,6.62,5.69 c0,4.44-2.56,5.86-6.62,5.86h-3.41l10.98,8.15h-5.59l-6.82-5.41v5.41h-3.21V10.56z M1217.48,19.08c1.8,0,3.21-0.48,3.21-2.83 c0-2.08-1.4-2.66-3.21-2.66h-4.84v5.49H1217.48z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a8e98d2fabb9ec0058019794876fddda.svg";
export { ForwardRef as ReactComponent };